export const thuocTinh = {
  sections: {
    list: { title: 'Thuộc tính hàng hóa' },
    detail: { title: 'Thuộc tính' },
    giaTri: { title: 'Giá trị thuộc tính' },
  },
  titles: { add: 'Thêm thuộc tính', edit: 'Sửa thuộc tính', create: 'Tạo thuộc tính' },
  columns: {
    code: 'Mã TT',
    summary: 'Tên thuộc tính',
    note: 'Mô tả',
    loaiInput: 'Loại nhập',
    moTa: 'Mô tả',
    status: 'Trạng thái',
    soGiaTri: 'Số GT',
    soHangHoa: 'Số HH',
    nguoiTao: 'Người tạo',
    ngayTao: 'Ngày tạo',
    ngayCapNhat: 'Ngày cập nhật',
    onOffAction: 'Bật tắt',
  },
  filter: {
    searchPlaceholder: 'Tìm theo mã / tên thuộc tính...',
    textDetailTitle: 'Bộ lọc chi tiết',
  },
  filters: {
    hintSection: 'Gợi ý',
    hintBody: 'Quản lý thuộc tính hàng hóa (Màu sắc, Size, Dung tích...).',
    statusAll: 'Tất cả',
    loaiInputAll: 'Tất cả loại',
  },
  status: {
    dangHoatDong: 'Đang hoạt động',
    ngungHoatDong: 'Ngừng hoạt động',
  },
  loaiInput: {
    text: 'Nhập tự do',
    select: 'Chọn từ danh sách',
    number: 'Số',
  },
  actions: {
    pause: 'Ngừng hoạt động',
    activate: 'Kích hoạt',
    addGiaTri: 'Thêm giá trị',
    editGiaTri: 'Sửa giá trị',
    xoaGiaTri: 'Xóa giá trị',
    quanLyGiaTri: 'Quản lý giá trị',
  },
  messages: {
    loadError: 'Không tải được danh sách thuộc tính.',
    deleteSuccess: 'Đã xóa thuộc tính.',
    noData: 'Không có thuộc tính.',
    listSummary: 'Tổng {count} mục',
    saveSuccess: 'Đã lưu thuộc tính.',
    statusChanged: 'Đã cập nhật trạng thái.',
    createSuccess: 'Tạo thuộc tính thành công',
    selectedCount: 'Đã chọn {count}',
    deleteSelected: 'Xóa đã chọn ({count})',
    bulkDeleteConfirm: 'Xóa {count} thuộc tính đã chọn?',
    bulkDeleteSuccess: 'Đã xóa {count} thuộc tính',
    bulkDeletePartial: 'Đã xóa {ok}/{total}. {failed} mục không xóa được.',
    bulkDeleteError: 'Xóa hàng loạt thất bại',
    bulkDeleteNoneSelected: 'Chưa chọn thuộc tính nào để xóa',
    hhCount: '{count} HH',
    gtCount: '{count} GT',
    giaTriSaveSuccess: 'Đã lưu giá trị thuộc tính.',
    giaTriDeleteSuccess: 'Đã xóa giá trị thuộc tính.',
    giaTriNoData: 'Chưa có giá trị nào. Thêm giá trị đầu tiên.',
    giaTriTrung: 'Giá trị này đã có trong danh sách.',
    giaTriHintAdd: 'Sau khi lưu thuộc tính, bạn có thể thêm các giá trị (Màu đỏ, Size L...).',
    giaTriInUse: 'Giá trị đang được {count} hàng hóa sử dụng, không thể xóa.',
  },
  form: {
    ten: 'Tên thuộc tính',
    maThuocTinh: 'Mã thuộc tính',
    moTa: 'Mô tả',
    loaiInput: 'Loại nhập',
    thuTu: 'Thứ tự',
    giaTri: 'Giá trị',
  },
  validation: {
    tenRequired: 'Vui lòng nhập tên thuộc tính.',
    giaTriRequired: 'Vui lòng nhập giá trị.',
  },
  placeholders: {
    formTitle: 'Thuộc tính',
    formBody: '',
    ten: 'Nhập tên thuộc tính (vd: Màu sắc)',
    maThuocTinh: 'Để trống sẽ tự sinh',
    nhapGiaTri: 'Nhập giá trị rồi nhấn Enter (vd: Đỏ, Xanh...)',
  },
  dropdown: {
    empty: '— Chọn thuộc tính —',
    giaTriEmpty: '— Chọn giá trị —',
  },
}
